import { fetchRaw } from "../client";

export { buildFilesUrl, FILES_BASE_URL } from "../filesUrl";
export type { ImageRef } from "../filesUrl";

export type FileUploadResult = {
  hash: string;
  filename: string;
  url: string;
};

export const filesService = {
  upload(file: File): Promise<FileUploadResult> {
    return filesService.uploadTo("/v1/profiles/files", file);
  },

  async uploadTo(endpoint: string, file: File): Promise<FileUploadResult> {
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetchRaw(endpoint, { method: "POST", body: formData });
    if (!response.ok) {
      let message = `Failed to upload file: HTTP ${response.status}`;
      try {
        const body = (await response.json()) as { error?: unknown };
        if (typeof body.error === "string") message = body.error;
      } catch {
        // keep default
      }
      throw new Error(message);
    }
    const raw = (await response.json()) as Record<string, unknown>;
    return {
      hash: String(raw.hash ?? ""),
      filename: String(raw.filename ?? file.name),
      url: String(raw.url ?? ""),
    };
  },
};
